import { useState, useEffect } from "react";
import userIcon from "../assets/user-icon.png";
import emailIcon from "../assets/at-icon.png";
import google from "../assets/Google.png";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { registerUser } from "../store/actions/auth-actions";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import PhoneNumber from "../components/app/PhoneNumber";

export const Signup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [userCountry, setUserCountry] = useState("");
  const [details, setDetails] = useState({
    name: "",
    company_key: "",
    email: "",
    password: "",
    password_confirmation: "",
    mobile: "",
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading, userToken, error, success } = useAppSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (error) {
      toast(error, {
        type: "error",
      });
    }
    // redirect user to login page if registration was successful
    if (success) {
      toast("Registration successful!!", {
        type: "success",
      });
      setTimeout(() => {
        navigate("/dashboard");
      }, 3000);
    }
    // redirect authenticated user to profile screen
    if (userToken) {
      console.log(userToken);
      navigate("/dashboard");
    }
  }, [navigate, userToken, success]);

  function signup(e: any) {
    e.preventDefault();
    if (details.password !== details.password_confirmation) {
      alert("invalid password!");
    }
    const payload = {
      ...details,
      country: userCountry,
    };
    dispatch(registerUser(payload));
  }
  function getMobile(dialCode: string, mobile: string) {
    setUserCountry(dialCode);
    setDetails({ ...details, mobile });
  }
  return (
    <div>
      <ToastContainer />
      <div className="md:grid grid-cols-2">
        <div className="hidden md:block">
          <div className="bg-primary min-h-screen w-[50%] fixed h-full"></div>
        </div>
        <div className="flex items-center min-h-screen relative">
          <div className="max-md:mx-6 md:max-w-[60%] w-full mx-auto">
            <div className="md:text-center">
              <h1 className="font-semibold text-[32px] mb-2">Sign Up</h1>
              <p className="secondary-text">
                Hello, Please fill the form below to get started
              </p>
            </div>
            <div className="my-10">
              <form action="" className="space-y-7" onSubmit={signup}>
                <div>
                  <label htmlFor="name" className="secondary-text">
                    Full Name
                  </label>
                  <div className="input-field">
                    <input
                      onChange={(e) =>
                        setDetails({ ...details, name: e.target.value })
                      }
                      type="text"
                      name="name"
                      required
                    />
                    <img src={userIcon} alt="" className="w-5 h-5" />
                  </div>
                </div>
                <div>
                  <label htmlFor="email" className="secondary-text">
                    Email
                  </label>
                  <div className="input-field">
                    <input
                      onChange={(e) =>
                        setDetails({ ...details, email: e.target.value })
                      }
                      type="email"
                      name="email"
                      required
                    />
                    <img src={emailIcon} alt="" className="w-5 h-5" />
                  </div>
                </div>
                <div>
                  <PhoneNumber returnValues={getMobile} />
                </div>
                <div>
                  <label htmlFor="password" className="secondary-text">
                    Create Password
                  </label>
                  <div className="input-field">
                    <input
                      onChange={(e) =>
                        setDetails({ ...details, password: e.target.value })
                      }
                      type={showPassword ? "text" : "password"}
                      name="password"
                      required
                    />
                    <div onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <label htmlFor="password" className="secondary-text">
                    Confirm Password
                  </label>
                  <div className="input-field">
                    <input
                      onChange={(e) =>
                        setDetails({
                          ...details,
                          password_confirmation: e.target.value,
                        })
                      }
                      type={showPassword ? "text" : "password"}
                      name="password"
                      required
                    />
                    <div onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-primary rounded-lg">
                  <button type="submit" className="w-full font-medium">
                    Sign Up
                  </button>
                </div>
              </form>
            </div>
            <div className="flex items-center">
              <div className="bg-[#d6d6d6] h-[2px] w-[45%]"></div>
              <p className="mx-5 secondary-text">Or</p>
              <div className="bg-[#d6d6d6] h-[2px] w-[45%]"></div>
            </div>
            <div className="mt-8">
              <div className="py-3 border border-border flex items-center justify-center space-x-4 rounded-lg">
                <div>
                  <img src={google} alt="" className="w-6 h-6" />
                </div>
                <div>
                  <p className="font-medium text-primaryBlack">
                    Sign up with google
                  </p>
                </div>
              </div>
            </div>
            <div className="my-8 text-center">
              <h2 className="secondary-text flex items-center justify-center">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="text-primary font-semibold hover:cursor-pointer"
                >
                  <p>Login</p>
                </Link>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
